module.exports = __webpack_public_path__ + "media/images/wave-aa50959e8af6fb171c79bdd385b306a7.png";